import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, mergeMap, switchMap } from 'rxjs/operators'

import { setUserMailboxId } from './actions'
import {
  EMAILS_PER_PAGE,
  FETCH_TEST_CAMPAIGN_EMAILS_ASYNC,
  FETCH_USER_EMAIL_ASYNC,
} from './constants'

const fetchTestCampaignEmailsEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(FETCH_TEST_CAMPAIGN_EMAILS_ASYNC.INITIATE, FETCH_USER_EMAIL_ASYNC.INITIATE),
    mergeMap((action) => {
      const isTestCampaign = action.type === FETCH_TEST_CAMPAIGN_EMAILS_ASYNC.INITIATE
      const successAction = isTestCampaign
        ? FETCH_TEST_CAMPAIGN_EMAILS_ASYNC.onSuccess
        : setUserMailboxId
      const errorAction = isTestCampaign
        ? FETCH_TEST_CAMPAIGN_EMAILS_ASYNC.onError
        : FETCH_USER_EMAIL_ASYNC.onError

      return api.mailboxes
        .getEmails(
          state$.value.partnerOptions.selectedCompany?.value,
          action.payload.search,
          false,
          action.payload.page,
          EMAILS_PER_PAGE
        )
        .pipe(
          switchMap((response) => of(successAction(response))),
          catchError((error) => of(epicsErrorHandler(errorAction, error, [400])))
        )
    })
  )

export default combineEpics(fetchTestCampaignEmailsEpic)
